<footer id="footer" class="footer footer-s4">
  <div class="container">

  </div>
  <div id="bottom" class="bottom-s3">
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <div class="copyright lt-sp02">
            ©{{ year | date: 'yyyy' }}, Naomi Céspedes.
          </div>
        </div>

        <div class="col-lg-6 copyright  ">
            <h4 class="title color-d11">Get a project? Let’s talk.</h4>
            <a href="mailto:lizcespedes0326@gmail.com" class="email color-s2 color-d15">lizcespedes0326@gmail.com</a>
        </div>

        <div class=" socials-list-hd s3 hv2  col-lg-2 copyright ">
          <a href="https://www.linkedin.com/in/naeliza/" class="bg-s1"><i class="fa fa-linkedin"
              aria-hidden="true"></i></a>
          <a href="mailto:lizcespedes0326@gmail.com" class="bg-s3"><i class="fa fa-google" aria-hidden="true"></i></a>
          <a href="https://github.com/Naeliza" class="bg-s4"><i class="fa fa-github" aria-hidden="true"></i></a>
        </div>
        <div class="col-lg-2">
        </div>
      </div>
    </div>
  </div>
</footer>
